import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { initDropdowns } from 'flowbite';
import { InputType, SelectOption } from './input-set.model';

@Component({
  selector: 'app-input-set',
  templateUrl: './input-set.component.html',
  styleUrl: './input-set.component.scss',
})
export class InputSetComponent implements OnChanges, OnInit, AfterViewInit {
  @ViewChild('fileInputElement') fileInputElement!: ElementRef;

  /** Input label */
  @Input() label = '';
  /** Input placeholder */
  @Input() placeholder = '';
  /** Input type */
  @Input() type: string = InputType.TEXT;
  /** Input format */
  @Input() format = '';
  /** Input form control */
  @Input() control: any;
  /** Clear input flag */
  @Input() clearInput = false;
  /** Select options */
  @Input() selectOptions: SelectOption[] = [];
  /** Prefix input icon */
  @Input() prefix = '';
  /** Suffix input icon */
  @Input() suffix = '';
  /** Submitting flag */
  @Input() submitting = false;
  /** for label */
  @Input() forLabel = '';
  /** Label link */
  @Input() labelLink = '';
  /** Link */
  @Input() link = '';
  /** Is required */
  @Input() isRequired = false;
  /** Key local save */
  @Input() keyLocalSave = '';
  /** Key local save */
  @Input() searchSelect = true;
  /** Initial Value */
  @Input() initialValue: string | undefined = '';
  /** Disabled */
  @Input() disabled: boolean | undefined = false;
  /** Text error */
  @Input() showTextError: boolean | undefined = true;
  /** Is multiple files */
  @Input() isMultiple = false;
  /** Send signature tag */
  @Output() sendSignature: EventEmitter<any> = new EventEmitter<any>();
  /** Send file */
  @Output() sendFile: EventEmitter<any> = new EventEmitter<any>();
  /** Input value */
  inputValue: string[] = [''];
  /** Input types */
  inputType = InputType;
  /** Width dropdown setting */
  widthDropdown = 0;
  /** Show password flag */
  showPassword = false;
  /** Error messages */
  errorMessages: any = {
    email: 'HOME.REGISTER_PAGE.ENTER_A_VALID_EMAIL',
    docType: 'HOME.REGISTER_PAGE.ENTER_A_VALID_DOCUMENT_NUMBER',
    telephone: 'HOME.REGISTER_PAGE.ENTER_A_VALID_TELEPHONE_NUMBER',
    password: 'HOME.REGISTER_PAGE.ENTER_MIN_CHARACTERS',
    confirmPassword: 'HOME.REGISTER_PAGE.ENTER_MIN_CHARACTERS',
    document_number: 'HOME.REGISTER_PAGE.ENTER_A_VALID_DOCUMENT_NUMBER',
    number: 'DASHBOARD.FORM GENERATED.ENTER_VALID_NUMBER',
  };
  /** Select options aux */
  selectOptionsAux: SelectOption[] = [];
  /** Multiples choice types */
  multipleChoiceTypes = [InputType.CHECK_MULTIPLE, InputType.RADIO_MULTIPLE];
  /** Multiples choice label */
  multipleChoiceLabel = '';
  /** Show modal sign */
  showModalSign = false;
  /** Inputs don't show clear option */
  inputsShowClearOption: string[] = [
    InputType.RADIO,
    InputType.CHECKBOX,
    InputType.RADIO_MULTIPLE,
    InputType.CHECK_MULTIPLE,
    InputType.SIGNATURE,
    InputType.DATE,
    InputType.PASSWORD,
  ];
  /**
   * On changes
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    this.submitting = changes.submitting?.currentValue ?? this.submitting;
  }

  ngOnInit(): void {
    if (this.keyLocalSave !== '') {
      const localData = localStorage.getItem(this.keyLocalSave);
      this.inputValue = this.initialValue ? [this.initialValue] : localData ? JSON.parse(localData) : [''];
      this.control.setValue(this.inputValue.filter(value => value !== '').join(','));
      if (this.disabled) this.control.disable();
      this.multipleChoiceLabel = this.inputValue.filter(value => value !== '').join(',');
    }
  }

  ngAfterViewInit(): void {
    const button = document.getElementById('dropdownSearchButton_' + this.forLabel) as HTMLButtonElement;
    button?.setAttribute('data-dropdown-toggle', 'dropdownSearch_' + this.forLabel);
    this.selectOptionsAux = this.selectOptions;
    initDropdowns();
  }

  temporalSaveData(): void {
    if (this.keyLocalSave !== '')
      localStorage.setItem(this.keyLocalSave, JSON.stringify(this.inputValue.filter(value => value !== '')));
    if (this.format !== this.inputType.RADIO_MULTIPLE) {
      const button = document.getElementById('dropdownSearchButton_' + this.forLabel) as HTMLButtonElement;
      button?.dispatchEvent(new Event('click'));
    }
  }

  filterOptions(event: any): void {
    if (event.target.value !== '') {
      this.selectOptions = this.selectOptionsAux.filter(option =>
        option.value.toLowerCase().includes(event.target.value.toLowerCase())
      );
    } else {
      this.selectOptions = this.selectOptionsAux;
    }
  }

  setCheckboxValue(event: any, idx: number, value: string): void {
    event.target.checked ? (this.inputValue[idx] = value) : (this.inputValue[idx] = '');
    this.control.setValue(this.inputValue.filter(value => value !== '').join(','));
    this.multipleChoiceLabel = this.inputValue.filter(value => value !== '').join(',');
    this.temporalSaveData();
  }

  setSignature(event: any) {
    this.control.setValue(event.base64);
    this.sendSignature.emit({
      ...event,
      name: this.forLabel,
    });
    this.showModalSign = false;
  }

  triggerFileInputClick(): void {
    this.fileInputElement.nativeElement.click();
  }

  onInputFileChange(event: any): void {
    this.control.setValue(event.target.files);
    this.sendFile.emit({
      name: this.forLabel,
      files: event.target.files,
    });
  }
}
